import { createFileRoute } from "@tanstack/react-router";

import { PodcastSection } from "@/features/podcast/components/PodcastSection";
import { SiteFooter } from "@/features/sales/storefront/components/SiteFooter";
import { SiteHeader } from "@/features/sales/storefront/components/SiteHeader";
import { PODCAST_CONFIG } from "@/features/podcast/podcast-config";
import { absoluteUrl } from "@/lib/seo";

export const Route = createFileRoute("/podcast")({
  head: () => ({
    meta: [
      {
        title: `${PODCAST_CONFIG.name} — ${PODCAST_CONFIG.tagline.replace(/\.$/, "")}`,
      },
      {
        name: "description",
        content: PODCAST_CONFIG.description,
      },
      { property: "og:title", content: PODCAST_CONFIG.name },
      {
        property: "og:description",
        content: PODCAST_CONFIG.shortDescription,
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: absoluteUrl("/podcast") },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: PODCAST_CONFIG.name },
      { name: "twitter:description", content: PODCAST_CONFIG.shortDescription },
    ],
    links: [{ rel: "canonical", href: absoluteUrl("/podcast") }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "PodcastSeries",
          name: PODCAST_CONFIG.name,
          description: PODCAST_CONFIG.description,
          url: absoluteUrl("/podcast"),
          image: absoluteUrl(PODCAST_CONFIG.coverImage),
          author: {
            "@type": "Person",
            name: PODCAST_CONFIG.author,
          },
          webFeed: PODCAST_CONFIG.rssUrl,
          inLanguage: "es",
          audience: {
            "@type": "Audience",
            audienceType: PODCAST_CONFIG.audience,
          },
          additionalProperty: [
            {
              "@type": "PropertyValue",
              name: "Formato",
              value: PODCAST_CONFIG.format,
            },
            {
              "@type": "PropertyValue",
              name: "Duración estándar",
              value: PODCAST_CONFIG.episodeDuration,
            },
          ],
        }),
      },
    ],
  }),
  component: PodcastPage,
});

function PodcastPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-black">
      <SiteHeader />
      <main id="main-content" className="flex-1">
        <PodcastSection />
      </main>
      <SiteFooter />
    </div>
  );
}
